import { useAutopilotProvider } from 'hooks/useAutopilotProvider'
import { observer } from 'mobx-react-lite'

export const AutoPilotProvider = observer(() => {
  useAutopilotProvider()

  return null
})
